import { Link } from "@tanstack/react-router";
import { Trophy, ChevronRight } from "lucide-react";
import { trackEvent } from "@/lib/audit";

/**
 * Always-visible top entry to Quinielas. Sits in the Home content area
 * above the pitch on desktop. Mobile keeps the existing inline CTA.
 */
export function QuinielaTopCTA() {
  return (
    <Link
      to="/quinielas"
      onClick={() => void trackEvent("quiniela_top_cta_clicked", { surface: "home_desktop_top" })}
      aria-label="Jugar Quiniela — predice el marcador y suma puntos"
      className="group hidden md:flex w-full items-center justify-between gap-4 rounded-2xl border border-amber-400/50 bg-gradient-to-r from-amber-500/15 via-amber-400/10 to-transparent px-4 py-3 transition hover:border-amber-400/80 hover:from-amber-500/25"
    >
      <span className="flex items-center gap-3 min-w-0">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/20 ring-1 ring-amber-400/40 text-amber-300">
          <Trophy className="h-5 w-5" />
        </span>
        <span className="min-w-0">
          <span className="block text-[13px] font-black tracking-tight text-foreground">
            Jugar Quiniela
          </span>
          <span className="block truncate text-[11px] font-medium text-muted-foreground">
            Predice el marcador y suma puntos
          </span>
        </span>
      </span>
      <span className="flex items-center gap-1.5 rounded-full bg-amber-500/20 px-3 py-1 text-[11px] font-black uppercase tracking-wider text-amber-300 ring-1 ring-amber-400/40 transition group-hover:bg-amber-500/30">
        Entrar
        <ChevronRight className="h-3.5 w-3.5 transition group-hover:translate-x-0.5" />
      </span>
    </Link>
  );
}